/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input} from '@angular/core';
import * as _ from 'lodash';
import template from './report-history.component.html';
import {ObjectTypeFinder} from '../common/constants/object-type';
import {ReportExecutionResource} from '../../components/api/resources/resource/execution-resources/report-execution.resource';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-report-history',
  template
})
export class ReportHistoryComponent {
  @Input() reportExecutions: any[] = [];
  @Input() size: string;
  @Input() hideEmptyMessage: string;

  resolved = false;
  collapseExecutions = true;
  private _objType: string;
  private _objId: string;

  constructor(@Inject(ReportExecutionResource) private ReportExecution: any,
              private readonly cdr: ChangeDetectorRef) {
  }

  @Input()
  set objType(value: string) {
    this._objType = value;
    this.updateReportExecutions();
  }

  get objType(): string {
    return this._objType;
  }

  @Input()
  set objId(value: string) {
    this._objId = value;
    this.updateReportExecutions();
  }

  get objId(): string {
    return this._objId;
  }

  get sortedExecutions(): any[] {
    return _.orderBy(this.reportExecutions, ['executionStartTime'], ['desc']);
  }

  private setReportExecutions(reportExecutions: any[], resolved = true): void {
    this.reportExecutions = reportExecutions || [];
    this.resolved = resolved;
  }

  private updateReportExecutions(): void {
    const apiParam = _.get(ObjectTypeFinder.findByCaps(this.objType), ['apiParam']);
    if (!(this.objType && this.objId && apiParam)) {
      this.setReportExecutions([]);
      return;
    }

    this.resolved = false;
    const params: any = {};
    params[apiParam] = this.objId;
    this.ReportExecution.query(params).$promise.then((page: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.setReportExecutions(page.results || []);
      });
    }, () => {
      deferMarkForCheck(this.cdr, () => {
        this.setReportExecutions([]);
      });
    });
  }
}
